document.addEventListener("DOMContentLoaded", function () {

  const track = document.querySelector(".creator-slider-track");

  if (!track) return;

  const section  = track.closest(".creator-slider");

  const viewport = section.querySelector(".creator-slider-viewport");

  const nextBtn = section.querySelector(".next");

  const prevBtn = section.querySelector(".prev");

  const originalCards =
    Array.from(track.querySelectorAll(".creator-card"));

  const total = originalCards.length;

  if (total === 0) return;

  function getVisible() {

    const w = window.innerWidth;

    if (w <= 600) return 1;

    if (w <= 991) return 2;

    return 4;
  }

  let visibleCount = getVisible();

  let index = 0;

  let autoTimer = null;

  function setCardWidth() {

    visibleCount = getVisible();

    const sliderW = viewport.offsetWidth;

    const gap = 20;

    const cardW =
      (sliderW - gap * (visibleCount - 1)) / visibleCount;

    track.querySelectorAll(".creator-card").forEach(card => {

      card.style.width = cardW + "px";

      card.style.minWidth = cardW + "px";

    });

    goTo(0, false);
  }

  function buildClones() {

    track.querySelectorAll(".creator-card.clone")
      .forEach(c => c.remove());

    originalCards.forEach(card => {

      const clone = card.cloneNode(true);

      clone.classList.add("clone");

      track.appendChild(clone);

    });
  }

  function cardWidth() {

    const c = track.querySelector(".creator-card");

    return c ? c.offsetWidth + 20 : 0;
  }

  function goTo(i, animate = true) {

    index = i;

    track.style.transition =
      animate ? "transform .5s ease" : "none";

    track.style.transform =
      `translateX(-${index * cardWidth()}px)`;
  }

  function slideNext() {

    index++;

    track.style.transition = "transform .5s ease";

    track.style.transform =
      `translateX(-${index * cardWidth()}px)`;

    if (index >= total) {

      setTimeout(() => {

        track.style.transition = "none";

        index = 0;

        track.style.transform = "translateX(0)";

      }, 520);
    }
  }

  function slidePrev() {

    if (index > 0) {

      index--;

      track.style.transition = "transform .5s ease";

      track.style.transform =
        `translateX(-${index * cardWidth()}px)`;

    } else {

      track.style.transition = "none";

      index = total - 1;

      track.style.transform =
        `translateX(-${index * cardWidth()}px)`;

      setTimeout(() => {

        track.style.transition = "transform .5s ease";

      }, 20);
    }
  }

  function startAuto() {

    if (window.innerWidth <= 991) return;

    stopAuto();

    autoTimer = setInterval(slideNext, 5000);
  }

  function stopAuto() {

    if (autoTimer) clearInterval(autoTimer);
  }

  nextBtn.addEventListener("click", () => {

    stopAuto();

    slideNext();

    startAuto();

  });

  prevBtn.addEventListener("click", () => {

    stopAuto();

    slidePrev();

    startAuto();

  });

  let touchStartX = 0;

  viewport.addEventListener("touchstart", e => {

    touchStartX = e.touches[0].clientX;

  }, { passive: true });

  viewport.addEventListener("touchend", e => {

    const diff =
      touchStartX - e.changedTouches[0].clientX;

    if (Math.abs(diff) > 40) {

      stopAuto();

      diff > 0 ? slideNext() : slidePrev();

      startAuto();
    }

  }, { passive: true });

  let resizeTimer;

  window.addEventListener("resize", () => {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {

      buildClones();

      setCardWidth();

      startAuto();

    }, 200);

  });

  buildClones();

  setCardWidth();

  startAuto();
  const iframes = section.querySelectorAll("iframe");
  iframes.forEach((iframe) => {

  iframe.addEventListener("mouseenter", () => {

    stopAuto();

  });

  iframe.addEventListener("mouseleave", () => {

    startAuto();

  });

});

});
